// PushNotificationsControlPage.jsx
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {
  AppBar,
  Toolbar,
  Typography,
  Container,
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Paper,
  Snackbar,
} from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { styled } from '@mui/system';

const StyledContainer = styled(Container)(({ theme }) => ({
  marginTop: theme.spacing(4),
  marginBottom: theme.spacing(4),
}));

const PushNotificationsControlPage = () => {
  // State for the modal dialog
  const [openDialog, setOpenDialog] = useState(false);
  // Form fields
  const [title, setTitle] = useState('');
  const [body, setBody] = useState('');
  // Status and notifications
  const [status, setStatus] = useState('');
  const [notifications, setNotifications] = useState([]);
  // Snackbar for status messages
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  // Fetch previously sent notifications on mount
  useEffect(() => {
    fetchNotifications();
  }, []);

  // Fetch notifications from backend (GET request)
  const fetchNotifications = async () => {
    try {
      const res = await axios.get('https://kirupam.shop/admin/admin_api/push.php');
      setNotifications(res.data.notifications || []);
    } catch (error) {
      console.error('Error fetching notifications:', error);
    }
  };

  // Open and close dialog handlers
  const handleOpenDialog = () => setOpenDialog(true);
  const handleCloseDialog = () => {
    setOpenDialog(false);
    setTitle('');
    setBody('');
  };

  // Submit notification (POST request)
  const handleSubmit = async () => {
    try {
      const res = await axios.post('https://kirupam.shop/admin/admin_api/push.php', { title, body });
      setStatus(res.data.status);
      setSnackbarOpen(true);
      handleCloseDialog();
      fetchNotifications();
    } catch (error) {
      console.error('Error sending notification:', error);
      setStatus('Error sending notification.');
      setSnackbarOpen(true);
    }
  };

  // DataGrid columns – adjust fields as needed based on your response
  const columns = [
    { field: 'id', headerName: 'ID', width: 220 },
    { field: 'title', headerName: 'Title', width: 200 },
    { field: 'body', headerName: 'Body', width: 300 },
    { field: 'created_at', headerName: 'Sent At', width: 200 },
  ];

  return (
    <>
      {/* Header */}
      <AppBar position="static" sx={{ mb: 2 }}>
        <Toolbar>
          <Typography variant="h6" sx={{ flexGrow: 1 }}>
            Push Notifications Control Panel
          </Typography>
          <Button color="inherit" onClick={handleOpenDialog}>
            Send Notification
          </Button>
        </Toolbar>
      </AppBar>

      <StyledContainer maxWidth="lg">
        {/* DataGrid: Sent Notifications */}
        <Paper sx={{ height: 500, width: '100%', p: 2 }}>
          <Typography variant="h5" sx={{ mb: 2 }}>
            Sent Notifications
          </Typography>
          <DataGrid
            rows={notifications}
            columns={columns}
            pageSize={10}
            rowsPerPageOptions={[10, 20, 50]}
            getRowId={(row) => row.id}
          />
        </Paper>
      </StyledContainer>

      {/* Modal Dialog for Sending Notification */}
      <Dialog open={openDialog} onClose={handleCloseDialog} fullWidth maxWidth="sm">
        <DialogTitle>Send Push Notification</DialogTitle>
        <DialogContent>
          <Box component="form" sx={{ mt: 2 }}>
            <TextField
              label="Notification Title"
              variant="outlined"
              fullWidth
              required
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              sx={{ mb: 2 }}
            />
            <TextField
              label="Notification Body"
              variant="outlined"
              fullWidth
              required
              multiline
              rows={3}
              value={body}
              onChange={(e) => setBody(e.target.value)}
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog}>Cancel</Button>
          <Button onClick={handleSubmit} variant="contained" color="primary">
            Send
          </Button>
        </DialogActions>
      </Dialog>

      {/* Snackbar for Status Messages */}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={() => setSnackbarOpen(false)}
        message={status}
      />
    </>
  );
};

export default PushNotificationsControlPage;
